<template lang="pug">
section#start-meals
  section.banner-area.relative
    .overlay.overlay-bg
    .container
      .row.fullscreen.align-items-center.justify-content-between
        .col-lg-6.col-md-7
          .banner-content(v-show="parsing")
            full-loader
          .banner-content(v-show="!parsing")
            h1(v-html="$t('startMeals.title')")
            p(v-html="$t('startMeals.subtitle')")
            form.subscription.relative
              input(autofocus, type='text', name='username', v-model="username", v-bind:placeholder="$t('startMeals.username')")
              transition(name="fade")
                button.primary-btn(v-bind:class="{disabled: usernameInputIncorrect}", v-on:click.prevent="getUsername")
                  | {{ $t('controls.next') }}
                  span.lnr.lnr-arrow-right
        .rpanel.col-lg-6.col-md-5
          .overlay.overlay-bg
            .counter
              p.step {{ $t('controls.step') }}
              p
                span.current 2
                span /4
      .row
        .col
          router-link.genric-btn.circle.link(to="/start/blood-sugar")
            span.lnr.lnr-arrow-left
            | &nbsp;
            | {{ $t('controls.back') }}
        .col.text-right
          router-link.skip-btn.genric-btn.circle.link(to="/start/location")
            | {{ $t('controls.skip') }}
            | &nbsp;
            span.lnr.lnr-arrow-right

  section.next-area.relative
    .overlay.overlay-bg
    .container
      .row
        .col-md-10.offset-md-1
          p.next-title {{ $t('controls.next') }}: {{ $t('startMeals.next') }}
</template>

<script>
import saveState from 'vue-save-state';
import moment from 'moment';
import api from '@/api';
import FullLoaer from '@/components/partials/FullLoader';

export default {
  name: 'StartMeals',
  components: {
    'full-loader': FullLoaer,
  },
  mixins: [saveState],
  data() {
    return {
      parsing: false,
      username: null,
    };
  },
  computed: {
    usernameInputIncorrect() {
      return this.username == null || this.username.length < 3;
    },
  },
  metaInfo() {
    return {
      title: this.$t('startMeals.meta.title'),
    };
  },
  methods: {
    getSaveStateConfig() {
      return {
        cacheKey: 'start.meals',
        saveProperties: ['username'],
      };
    },
    getUsername() {
      if (!this.username || this.usernameInputIncorrect) return;
      this.parsing = true;
      const start = moment(this.$store.firstDate).format('YYYY-MM-DD');
      const end = moment(this.$store.lastDate).format('YYYY-MM-DD');
      api.get(`/food-diary/${this.username}?from=${start}&to=${end}`)
        .then((res) => {
          const meals = res.data.map((meal) => {
            meal.date = new Date(meal.date);
            return meal;
          });
          this.$store.sugarData.getCollection('meals').clear();
          this.$store.sugarData.getCollection('meals').insert(meals);
          this.parsing = false;
          this.$router.push('/start/location');
        })
        .catch((err) => {
          console.log(err);
          this.parsing = false;
        });
    },
  },
  mounted() {
  },
};
</script>

<style lang="stylus" scoped>
@import '../../assets/css/variables.styl'

#start-meals
  overflow hidden
  background white

  .next-btn
    margin-left 15px

.next-area
  background color-main
  padding base-padding * 2
  background url(/static/img/hypnotize.png) repeat
  .overlay-bg
    padding base-padding
    background rgba(color-main, .8)
  p
    color white
    font-size 2.5em
    font-weight 200
    text-align center
    font-variant small-caps
    text-transform lowercase
    letter-spacing 0.2em
    line-height 1em

.banner-area
  padding-bottom base-padding
  .banner-content
    padding-right base-padding
  //border-bottom 1px solid rgba(color-base, .25)

.rpanel
  background url(/static/img/meal.jpg) no-repeat center/cover
  //width 50%
  height 100%
  top 0px
  right 0
  position absolute

  .overlay-bg
    background rgba(226, 109, 92, 0.8)
    display flex
    align-items center
    text-align center

  .counter
    margin auto
    color white
    font-size 15em
    span:not(.current)
      font-weight 200
      opacity .75
    .step
      font-size 0.2em
      font-weight 200
      font-variant small-caps
      text-transform lowercase
      letter-spacing 0.3em
      position relative
      top -120px
    .current
      font-weight 900

@media (max-width: size-sm)
  .rpanel
    display none
    visibility hidden
</style>



// WEBPACK FOOTER //
// src/components/pages/Start.Meals.vue